import axios from 'axios';

// 建立 axios 實例，初始化時不存取 store
const apiClient = axios.create({
  baseURL: '', // 將在請求攔截器中動態設定
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// 請求攔截器
apiClient.interceptors.request.use(
  (config) => {
    // 動態引入 store 以避免循環依賴
    const store = require('@/store').default;
    
    // 從 store 動態設定 baseURL
    if (!config.baseURL || config.baseURL === '') {
      config.baseURL = store.state.src + store.state.subDirectory;
    }
    
    // 如果有 JWT token，則將其加入請求標頭
    const token = localStorage.getItem('loginJWT');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// 回應攔截器
apiClient.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // 處理常見錯誤
    if (error.response) {
      switch (error.response.status) {
        case 401:
          // 未授權 - 清除 token 並重定向到登入頁面
          localStorage.removeItem('loginJWT');
          localStorage.removeItem('loginToken');
          localStorage.removeItem('userInfo');
          if (window.location.pathname !== '/') {
            window.location.href = '/';
          }
          break;
        case 403:
          // 禁止存取
          console.error('Access forbidden');
          break;
        case 500:
          // 伺服器錯誤
          console.error('Server error');
          break;
        default:
          break;
      }
    }
    return Promise.reject(error);
  }
);

export default apiClient;
